import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../../../Dashboard/Driveanalysis/NoData';
import ChartLoader from '../../../Dashboard/Driveanalysis/ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";


function NetEnergyBar_Orion({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState();

  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<0.25": { per: 0, count: 0 },
      "0.5": { per: 0, count: 0 },
      "0.75": { per: 0, count: 0 },
      "1": { per: 0, count: 0 },
      "1.25": { per: 0, count: 0 },
      "1.5": { per: 0, count: 0 },
      // "1.9": { per: 0, count: 0 },
      // "2": { per: 0, count: 0 },
      ">1.6": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {

      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val?.["less0.25"].value > 0) {
          responce["<0.25"] = { per: parseInt((t_val?.["less0.25"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less0.25"].value) };
        }
        if (t_val?.["less0.25_0.5"].value > 0) {
          responce["0.5"] = { per: parseInt((t_val?.["less0.25_0.5"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less0.25_0.5"].value) };
        }
        if (t_val?.["less0.5_0.75"].value > 0) {
          responce["0.75"] = { per: parseInt((t_val?.["less0.5_0.75"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less0.5_0.75"].value) };
        }
        if (t_val?.["less0.75_1"].value > 0) {
          responce["1"] = { per: parseInt((t_val?.["less0.75_1"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less0.75_1"].value) };
        }
        if (t_val?.["less1_1.25"].value > 0) {
          responce["1.25"] = { per: parseInt((t_val?.["less1_1.25"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less1_1.25"].value) };
        }
        if (t_val?.["less1.25_1.5"].value > 0) {
          responce["1.5"] = { per: parseInt((t_val?.["less1.25_1.5"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["less1.25_1.5"].value) };
        }
        // if (t_val.B18_19.value > 0) {
        //   responce["1.9"] = { per: parseInt((t_val.B18_19.value / t_val.doc_count) * 100), count: parseInt(t_val.B18_19.value) };
        // }
        // if (t_val.B19_20.value > 0) {
        //   responce["2"] = { per: parseInt((t_val.B19_20.value / t_val.doc_count) * 100), count: parseInt(t_val.B19_20.value) };
        // }
        if (t_val?.["greater_1.6"].value > 0) {
          responce[">1.6"] = { per: parseInt((t_val?.["greater_1.6"].value / t_val.doc_count) * 100), count: parseInt(t_val?.["greater_1.6"].value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]

        let loop_keys = Object.keys(responce);
        // loop_keys = ["<1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2", ">1.8"]
        loop_keys = ["<0.25", "0.5", "0.75", "1", "1.25", "1.5", ">1.6"]
        loop_keys.map(x => {
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })

        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }
  const appyDatakwh = (data) => {
    const res_result = data;
    let responce = {
      "<50": { per: 0, count: 0 },
      "75": { per: 0, count: 0 },
      "100": { per: 0, count: 0 },
      "125": { per: 0, count: 0 },
      "150": { per: 0, count: 0 },
      "175": { per: 0, count: 0 },
      "200": { per: 0, count: 0 },

      // "<=147": { per: 0, count: 0 },
      // ">150": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {

      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val.less50.value > 0) {
          responce["<50"] = { per: parseInt((t_val.less50.value / t_val.doc_count) * 100), count: parseInt(t_val.less50.value) };
        }
        if (t_val.less50_75.value > 0) {
          responce["75"] = { per: parseInt((t_val.less50_75.value / t_val.doc_count) * 100), count: parseInt(t_val.less50_75.value) };
        }
        if (t_val.less75_100.value > 0) {
          responce["100"] = { per: parseInt((t_val.less75_100.value / t_val.doc_count) * 100), count: parseInt(t_val.less75_100.value) };
        }
        if (t_val.less100_125.value > 0) {
          responce["125"] = { per: parseInt((t_val.less100_125.value / t_val.doc_count) * 100), count: parseInt(t_val.less100_125.value) };
        }
        if (t_val.less125_150.value > 0) {
          responce["150"] = { per: parseInt((t_val.less125_150.value / t_val.doc_count) * 100), count: parseInt(t_val.less125_150.value) };
        }
        if (t_val.less150_175.value > 0) {
          responce["175"] = { per: parseInt((t_val.less150_175.value / t_val.doc_count) * 100), count: parseInt(t_val.less150_175.value) };
        }
        if (t_val.less175_200.value > 0) {
          responce["200"] = { per: parseInt((t_val.less175_200.value / t_val.doc_count) * 100), count: parseInt(t_val.less175_200.value) };
        }
        // if (t_val.less125_147.value > 0) {
        //   // responce["150"] = { per: parseInt((t_val.less125_150.value / t_val.doc_count) * 100), count: parseInt(t_val.less125_150.value) };
        //   responce["<=147"] = { per: parseInt((t_val.less125_147.value / t_val.doc_count) * 100), count: parseInt(t_val.less125_147.value) };
        // }
        // if (t_val.B300_350.value > 0) {
        //   responce[">150"] = { per: parseInt((t_val.B300_350.value / t_val.doc_count) * 100), count: parseInt(t_val.B300_350.value) };
        // }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]
        let loop_keys = Object.keys(responce);
        // loop_keys = ["<50", "75", "100", "125", "150"]
        loop_keys = ["<50", "75", "100", "125","150","175","200" /* "<=147" */]
        loop_keys.map(x => {
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: fieldname,
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: "Discharge Cycle",
      // title: "Discharge Count",
      minValue: 0,
      format: '#\'%\'',
      // format: '#\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    if (apiend === "orion_drive_api/energyconsuptionbar_whperkm_vehicle") {
      SetFieldName("kWh/km")
      fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
    }
    else {
      SetFieldName("kWh")
      fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyDatakwh)
    }
  }, [gloablfilter, apiend])

  return (
    <>
      <div className=" p-2">
        <div className="v-title">
          <div className="chartHGT">
            <WaterMark />
            {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="190px" data={chartdata} options={options} />)}
          </div>
        </div>
      </div>
    </>
  );
}

export default NetEnergyBar_Orion;
